import { Phone, Mail, MapPin, Clock, Building2 } from "lucide-react";
import LegalLayout, { COMPANY } from "./LegalLayout";

export default function Iletisim() {
  const cards = [
    { icon: Phone, label: "Telefon", value: COMPANY.phone, href: `tel:${COMPANY.phone.replace(/\s/g, "")}`, testid: "contact-phone" },
    { icon: Mail, label: "E-posta", value: COMPANY.email, href: `mailto:${COMPANY.email}`, testid: "contact-email" },
    { icon: MapPin, label: "Adres", value: COMPANY.address, testid: "contact-address" },
    { icon: Clock, label: "Destek Saatleri", value: "Hafta içi 09:00 – 19:00\nHafta sonu · Sadece e-posta", testid: "contact-hours" },
  ];

  return (
    <LegalLayout eyebrow="İletişim" title="Bize Ulaşın" updated={null}>
      <p>Sorularınız, iş ortaklığı teklifleriniz, teknik destek talepleriniz veya iade / iptal işlemleri için aşağıdaki kanallardan bize her zaman ulaşabilirsiniz. Tüm mesajlar en geç <strong>1 iş günü</strong> içinde yanıtlanır.</p>

      {/* Contact cards */}
      <div className="not-prose grid sm:grid-cols-2 gap-4 mt-8">
        {cards.map((c, i) => {
          const Wrapper = c.href ? "a" : "div";
          const props = c.href ? { href: c.href } : {};
          return (
            <Wrapper
              key={i}
              {...props}
              data-testid={c.testid}
              className="group border border-white/10 bg-[#080808]/70 p-5 hover:border-[--gold]/40 transition-colors block"
            >
              <c.icon size={16} style={{ color: "var(--gold)" }} />
              <div className="label-caps mt-3">{c.label}</div>
              <div
                className="text-white text-base sm:text-lg mt-1 group-hover:text-[--gold] transition-colors whitespace-pre-line break-words"
                style={{ overflowWrap: "anywhere" }}
              >
                {c.value}
              </div>
            </Wrapper>
          );
        })}
      </div>

      {/* Legal entity block */}
      <div className="not-prose mt-8 border border-white/10 p-5">
        <div className="flex items-center gap-2 mb-3">
          <Building2 size={16} style={{ color: "var(--gold)" }} />
          <span className="label-caps">İşletme Bilgileri</span>
        </div>
        <ul className="space-y-1.5 text-sm text-neutral-300">
          <li><span className="text-neutral-500">Unvan:</span> {COMPANY.legalName}</li>
          <li><span className="text-neutral-500">Marka:</span> {COMPANY.brand}</li>
          <li><span className="text-neutral-500">Web:</span> {COMPANY.website}</li>
          <li><span className="text-neutral-500">Adres:</span> {COMPANY.address}</li>
          <li><span className="text-neutral-500">Telefon:</span> {COMPANY.phone}</li>
          <li><span className="text-neutral-500">E-posta:</span> <a href={`mailto:${COMPANY.email}`} className="text-[--gold]" style={{color:"var(--gold)"}}>{COMPANY.email}</a></li>
        </ul>
      </div>

      <h2 className="mt-10">Şikayet ve Öneri</h2>
      <p>Hizmet kalitemiz sizin geri bildirimlerinizle şekilleniyor. Şikayetlerinizi ve önerilerinizi doğrudan <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> adresine iletebilirsiniz. Şikayetler için ayrıca T.C. Ticaret Bakanlığı bünyesindeki <a href="https://www.tuketici.gov.tr" target="_blank" rel="noreferrer">Tüketici Hakem Heyeti</a>'ne başvurma hakkınız saklıdır.</p>
    </LegalLayout>
  );
}
